export default __webpack_public_path__ + "static/media/pexels-rodolfo-clix-1596888.1a0dfb2a.jpg";